var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdatesUnread(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z",
    fill: "#3375BB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0007 12C16.9211 12 17.6673 11.2538 17.6673 10.3334C17.6673 9.41288 16.9211 8.66669 16.0007 8.66669C15.0802 8.66669 14.334 9.41288 14.334 10.3334C14.334 11.2538 15.0802 12 16.0007 12Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.667 14H17.3337V23.3333H14.667V14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdatesUnread);
export default __webpack_public_path__ + "static/media/updates_unread.f6b1587978fd764abe32a95c744464ce.svg";
export { ForwardRef as ReactComponent };